import { render } from "./sms-template-modal.vue?vue&type=template&id=2ceb475a"
import script from "./sms-template-modal.vue?vue&type=script&lang=js"
export * from "./sms-template-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__